<template>
    <div class="discuss-cpl-item dsp-flex" @click="clickItem">
        <div class="discuss-cpli-select">
            <i class="iconfont " v-bind:class="{'icon-unselected': !itemData.selected, 'icon-selected': itemData.selected}"></i>
        </div>
        <img class="discuss-cpli-img" :src="itemData.avatar" alt="">
        <span class="discuss-cpli-name">{{itemData.nickname}}</span>
    </div>
</template>

<script>
export default {
    name: 'DiscussChooseItem',
    props: {
        itemData: {
            type: Object,
            default() { return {} }
        },
        itemFunc: {
            type: Function,
            default() { return function(){} }
        }
    },
    data() {
        return {
            avatarUrl: require('../../assets/images/avatar.png'),
        }
    },
    mounted() {
        this.$bus.on('updateChooseItem----', this.updateItem)
    },
    methods: {
        updateItem() {
        },
        clickItem() {
            if(this.itemFunc && typeof(this.itemFunc) == 'function') {
                this.itemFunc(this.itemData);
            }
        }
    }
}
</script>